<template>
    <VueSlickCarousel v-bind="settings" class="pb-8 lg:pb-16">
        <slot />
        <template #prevArrow>
            <button class="absolute bottom-0 lg:bottom-5 right-20 z-50 group transition-all hover:pr-2">
                <i class="fa-light fa-arrow-left text-2xl group-hover:text-lys"></i>
            </button>
        </template>
        <template #nextArrow>
            <button class="absolute bottom-0 lg:bottom-5 right-8 z-50 group transition-all hover:pl-2 hover:right-6">
                <i class="fa-light fa-arrow-right text-2xl group-hover:text-lys"></i>
            </button>
        </template>

    </VueSlickCarousel>
</template>
 
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
//import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'MultiSlider',
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        slidesToShow: 3,
        arrows: true,
        dots: false,
        infinite: false,
        touch: true,
        responsive: [
                {
                    "breakpoint": 1024,
                    "settings": {
                        "slidesToShow": 1,
                    }
                }
            ]
        },
    };
  },
};
</script>